/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from "@hookform/resolvers/yup";
import DeleteModal from "Components/Common/DeleteModal";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import * as yup from "yup";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { SortingState } from "@tanstack/react-table";
import Loader from "Components/Common/Loader";
import { toast, ToastContainer } from "react-toastify";
import _ from "lodash";
import moment from "moment";
import { deleteBulkMessage } from "api/mutators/message";
import { useTranslation } from "react-i18next";
import NotificationsFilter from "./NotificationsFilter";
import DigitalTableContainer from "../../Components/Common/DigitalTableContainer";
import { fetchMessages } from "api/queries/message";
import { MessageDto, MessageDtoStatusEnum } from "generated/apiMessages";
import { getLoggedinUser } from "helpers/api_helper";
import BreadCrumb from "Components/Common/BreadCrumb";

import { signAsRead } from "api/mutators/message";

const Notifications = () => {
  const { t } = useTranslation("translation", { keyPrefix: "NOTIFICATIONS" });

  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [isMultiDeleteButton, setIsMultiDeleteButton] =
    useState<boolean>(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);
  const [message, setMessage] = useState<MessageDto | null>(null);

  const [search, setSearch] = useState<string>("");

  const [selectedRows, setSelectedRows] = useState<number[] >([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false)

  const [pageIndex, setPageIndex] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [orderBy, setOrderBy] = useState<any[]>([{createdAt: 'desc'}]);



  const mutationSignAsRead = useMutation({
    mutationFn: signAsRead,
    onError: (error: any) => {
      toast.error("Error! Museum not updated", { autoClose: 3000 });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fetchMessages"] });
      queryClient.invalidateQueries({ queryKey: ["fetchMessagesNoRead"] });
    },
  });


  useEffect(() => {
    mutationSignAsRead.mutate();
  }, []);

  const schema = yup.object().shape({
    search: yup.string().required("Search is required"),
    status: yup.object().shape({
      value: yup
        .mixed<MessageDtoStatusEnum>()
        .oneOf(Object.values(MessageDtoStatusEnum)),
      label: yup.string().required("status is required"),
    }),
  });


  const defaultValues = {
    search: "",
    status: { label: "All", value: undefined },
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });


  const debounceFunction = useCallback(
    _.debounce((value) => {
      setSearch(value);
    }, 500),
    []
  );

   const { isPending, data, error } = useQuery<any>({
     queryKey: fetchMessages.queryKey([
       search,
       { ...methods.watch(), pageIndex, pageSize, orderBy },
     ]),
     queryFn: () =>
      fetchMessages.queryFn({
         orderBy,
         take: pageSize,
         skip: pageIndex * pageSize,
         filter: {
          managerId: getLoggedinUser().uid,
           status: methods.watch().status.value as MessageDtoStatusEnum,
           search,
         },
       }),
   });


   const deleteMultiple = async () => {

    await mutation.mutate({ ids: selectedRows });

  };

  const toggleCheckAll = () => {
    const newCheckedState = !isCheckedAll;
    setIsCheckedAll(newCheckedState);
    setSelectedRows(newCheckedState && data?.data ? data?.data?.map((row: any) => row.id) : []); // Seleziona o deseleziona tutto
    setIsMultiDeleteButton(!isCheckedAll);
  };

  // Funzione per gestire il toggle di una singola riga
  const toggleRowSelection = (id: number) => {

    if (selectedRows?.includes(id)) {
      if(selectedRows.length <=1 )
        setIsMultiDeleteButton(false);
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id)); // Deseleziona

    } else {
      setIsMultiDeleteButton(true);
      setSelectedRows([...selectedRows, id]); // Seleziona
    }
  };

  const handleValidDate = (date: any) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time: any) => {
    let orario = moment(new Date(time)).format("HH:mm");
    return orario;
  };

  const onClickDelete = (message: any) => {
    setMessage(message);
    setDeleteModal(true);
  };

  // Column
  const columns =  [
      {
        header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            checked={isCheckedAll}
            onChange={toggleCheckAll}
          />
        ),
        cell: (cell: any) => {
          return (
            <input
              type="checkbox"
              className="orderCheckBox form-check-input"
              checked={selectedRows.includes(cell.getValue())}
              onChange={() => toggleRowSelection(cell.getValue())}
            />
          );
        },
        id: "#",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: `${t("DETAILS:TABLE:TITLE")}`,
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: `${t("DETAILS:TABLE:MESSAGE")}`,
        accessorKey: "message",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: `${t("DETAILS:TABLE:STATUS")}`,
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          switch (cell.getValue()) {
            case MessageDtoStatusEnum.NoReaded:
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  {" "}
                  {"No Read"}{" "}
                </span>
              );
            case MessageDtoStatusEnum.Readed:
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  {" "}
                  {"Read"}{" "}
                </span>
              );
          }
        },
      },
      {
        header: `${t("DETAILS:TABLE:CREATION_DATE")}`,
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <>
            {handleValidDate(cell.getValue())},
            <small className="text-muted">
              {" "}
              {handleValidTime(cell.getValue())}
            </small>
          </>
        ),
      },
      {
        header: `${t("DETAILS:TABLE:ACTIONS")}`,
        cell: (cellProps: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const note = cellProps.row.original;
                    onClickDelete(note);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ];



  const mutation = useMutation({
    mutationFn: deleteBulkMessage,
    onError: (error: any) => {
      const checkall: any = document.getElementById("checkBoxAll");
      checkall.checked = false;

      setIsMultiDeleteButton(false);

      queryClient.invalidateQueries({ queryKey: ["fetchMessages"] });
      toast.error("Error! Notifications not deleted", { autoClose: 3000 });
    },
    onSuccess: () => {
      const checkall: any = document.getElementById("checkBoxAll");

      checkall.checked = false;

      setIsMultiDeleteButton(false);

      queryClient.invalidateQueries({ queryKey: ["fetchMessages"] });
      toast.success("Notifications Deleted Successfully", { autoClose: 3000 });
    },
  });

  const handleDeleteMessage = () => {
    if (message) {
      mutation.mutate({ ids: [message.id] });
      setDeleteModal(false);
    }
  };


  return (
    <div className="page-content">
      <FormProvider {...methods}>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteMessage}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <Container fluid>
        <BreadCrumb title={t("LAYOUT:TITLE")} pageTitle="Menù" />
          <Row>
            <Col lg={12}>
              <Card id="notificationsList">
                <CardHeader className="card-header border-0">
                  <Row className="align-items-center gy-3">
                    <div className="col-sm">
                      <h5 className="card-title mb-0">{t("LAYOUT:TITLE")}</h5>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-1 flex-wrap">
                        {isMultiDeleteButton && (
                          <button
                            className="btn btn-soft-danger"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            <i className="ri-delete-bin-2-line"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <NotificationsFilter debounceFn={debounceFunction} />
                <CardBody className="pt-0">
                  <div>
                     {!isPending && data?.data ? (
                      <DigitalTableContainer
                        columns={columns}
                        data={data?.data || []}
                        numberOfRows={data?.count}
                        setPageIndex={setPageIndex}
                        setPageSize={setPageSize}
                        setSorting={setSorting}
                        pageSize={pageSize}
                        pageIndex={pageIndex}
                        sorting={sorting}
                        divClass="table-responsive table-card mb-1 mt-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-muted text-uppercase"
                      />
                    ) : (
                      <Loader error={error} />
                    )} 
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </FormProvider>
    </div>
  );
};

export default Notifications;
